import { Component, OnInit, inject, input } from '@angular/core'
import { BadgeService } from 'src/app/core/services/badge.service'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { LabelComponent } from '../label/label.component'
import { IBadgeSetting } from 'src/app/core/interfaces/badge.interface'

@Component({
  selector: 'app-badges-container',
  template: `
    @if (enabled() && filteredBadges.length > 0) {
      <div class="grouped">
      @for (badge of filteredBadges; track $index) {
        <app-label
          [text]="badge.label"
        ></app-label>
      }
      @if (badges.length > filteredBadges.length) {
        <app-label
        [text]="'+ ' + (badges.length - filteredBadges.length)"
        ></app-label>
      }
      </div>
    }
  `,
  styles: [`
    :host {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      max-height: 28px;
      overflow: hidden;
    }

    .grouped {
      display: flex;
      gap: 10px;
      flex-wrap: nowrap;
    }
  `],
  imports: [CommonModule, LabelComponent, MatIconModule]
})
export class BadgesContainerComponent implements OnInit {
  private _badgeService: BadgeService = inject(BadgeService)

  MAX_DISPLAYED_BADGES = 2
  enabled = input(false)
  asset = input<IAsset>()

  badges: IBadgeSetting[] = []
  filteredBadges: IBadgeSetting[] = []

  ngOnInit(): void {
    this.badges = this._badgeService.getBadgesForData(this.asset())
    // Limit to MAX_DISPLAYED_BADGES badges for display
    this.filteredBadges = this.badges.slice(0, this.MAX_DISPLAYED_BADGES)
  }
}
